<template>
<div class="">
    <button @click="addCompare($event)" class="btn btn--dark-ad btn--listing-compare tx-14 flex mb-4 sm:mb-6">
        <span class="tx-18 mr-2"><i class="fas fa-exchange-alt"></i></span>
        <!-- <img class="mr-2" width="20px" src="/assets/images/helpers/icon-compare.svg" alt=""> -->
        Comparar
    </button>
</div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            'product_id': {
                type: Number
            }
        },

        data() {
            return {
                user_id: null,

                formData: null,
                err: {}
            }
        },

        computed: {
            ...mapState(['user']),
        },

        watch: {
            user(state) {
                let vm = this;
                if ( state.id !== undefined ) {
                    vm.user_id = state.id;
                }
            }
        },

        methods: {

            async addCompare(event) {
                event.preventDefault();
                let vm = this;

                if (vm.product_id ) {

                    vm.resetForms();
                    vm.formData.append('product_id', vm.product_id);
                    vm.formData.append('user_id', vm.user_id);

                    try {
                        let {data} = await axios.post('/client/comparatives', vm.formData)
                        .then(response => {
                            vm.$store.dispatch('comparative/getComparatives');
                            vm.$parent.$refs.tray.$refs.trigger_compare_tray.click();
                        }).catch(error => {
                            vm.showErrors(error);
                        });

                    } catch (error) { }
                }
            },

            resetForms(){
                let vm = this;
                vm.formData = new FormData();
                vm.err = [];
            },

            showErrors(error = null){
                let vm = this;
                if ( error ) {
                    vm.err = error.response.data;
                }
                vm.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: vm.err.message ? vm.err.message : 'Se encontraron algunos errores en el formulario',
                });
            }

        }
    }
</script>